import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import DialogsWithIcon from '../DialogsWithIcon';

import './DialogWithSuccessLayout.theme.scss';

export default function DialogWithSuccessLayout(props) {
  const {
    className,
    headerClassName,
    headerTitleClassName,
    contentClassName,
    footerClassName,

    header,
    footer,
    children,
  } = props;

  return (
    <DialogsWithIcon
      {...props}
      className={classnames(className, 'dialog-with-success-layout')}
      character={
        <svg className="dialog-with-success-layout-header-icon-svg">
          <use xlinkHref="#icon-check" />
        </svg>
      }
      layoutType='success'
      headerClassName={classnames(headerClassName, 'dialog-with-success-layout-header')}
      headerTitleClassName={classnames(headerTitleClassName, 'dialog-with-success-layout-header-title')}
      contentClassName={classnames(contentClassName, 'dialog-with-success-layout-content-wrapper')}
      footerClassName={classnames(footerClassName, 'dialog-with-success-layout-footer')}
      header={header}
      footer={footer}
    >
      {children}
    </DialogsWithIcon>
  );
}

DialogWithSuccessLayout.propTypes = {
  className: PropTypes.string,
  headerClassName: PropTypes.string,
  contentClassName: PropTypes.string,
  footerClassName: PropTypes.string,
  header: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  footer: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ])
};
